import { GeometryFeatureBase } from './geometry-feature.base';
import { MapObject, MapObjectId } from '../map-object';

/** One business object whose map geometry is a path. */
export interface PathMapObject<
  TId extends MapObjectId = MapObjectId,
> extends MapObject<TId> {
  readonly pathGeoJson: string | null;
}

/** Base lifecycle for line-backed business features such as Sales Routes. */
export abstract class PathFeatureBase<TObject extends PathMapObject>
extends GeometryFeatureBase<TObject> {
  readonly geometryType = 'path' as const;
}
